import React from 'react'
import { Card, Timeline, Space, Typography } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { formatTime, formatTimelineItem } from '../utils/formatters'
import { groupActivitiesByCaregiver } from '../utils/filters'

const { Text } = Typography

const ActivityTimeline = ({ data, caregivers }) => {
  const activitiesByCaregiver = groupActivitiesByCaregiver(caregivers, data)

  return (
    <div style={{ padding: '0 16px' }}>
      {activitiesByCaregiver.map(({ caregiver, activities }) => (
        <Card
          title={
            <Space>
              <UserOutlined />
              <span>{caregiver}</span>
            </Space>
          }
          style={{ marginBottom: '16px' }}
          key={caregiver}
        >
          <Timeline mode='left'>
            {activities.map((activity) => (
              <Timeline.Item
                key={activity.activityId}
                color={activity.status === 'Completed' ? 'green' : activity.status === 'Cancelled' ? 'red' : 'blue'}
                label={formatTime(activity.startTime)}
              >
                {formatTimelineItem(activity)}
              </Timeline.Item>
            ))}
          </Timeline>
        </Card>
      ))}

      {activitiesByCaregiver.length === 0 && (
        <Card>
          <Text>No activities match your search criteria.</Text>
        </Card>
      )}
    </div>
  )
}

export default ActivityTimeline
